import { IUserProfile, defaultProfile } from "./models";

export default class UserState {
  loaded: boolean = false;
  profile: IUserProfile = defaultProfile
}
